import {
  columnFilteringFeature,
  columnOrderingFeature,
  columnPinningFeature,
  columnResizingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createFilteredRowModel,
  createSortedRowModel,
  filterFns,
  rowPinningFeature,
  rowSortingFeature,
  sortFns,
  tableFeatures,
} from "@tanstack/react-table";
import type {
  Cell,
  CellContext,
  CellData,
  Column,
  ColumnDef,
  Header,
  HeaderGroup,
  Row,
  RowData,
  Table,
} from "@tanstack/react-table";

// Features enregistrées par tous les tableaux de la Console (react-table 9 n'active que ce qu'on déclare).
export const tanStackFeatures = tableFeatures({
  columnVisibilityFeature,
  columnFilteringFeature,
  rowSortingFeature,
  columnSizingFeature,
  columnResizingFeature,
  columnPinningFeature,
  columnOrderingFeature,
  rowPinningFeature,
  filteredRowModel: createFilteredRowModel(),
  sortedRowModel: createSortedRowModel(),
  filterFns,
  sortFns,
});

export type AppTableFeatures = typeof tanStackFeatures;

export type AppColumnDef<TData extends RowData, TValue extends CellData = CellData> = ColumnDef<AppTableFeatures, TData, TValue>;
export type AppCellContext<TData extends RowData, TValue extends CellData = CellData> = CellContext<AppTableFeatures, TData, TValue>;
export type AppTable<TData extends RowData> = Table<AppTableFeatures, TData>;
export type AppRow<TData extends RowData> = Row<AppTableFeatures, TData>;
export type AppColumn<TData extends RowData, TValue extends CellData = CellData> = Column<AppTableFeatures, TData, TValue>;
export type AppCell<TData extends RowData, TValue extends CellData = CellData> = Cell<AppTableFeatures, TData, TValue>;
export type AppHeader<TData extends RowData, TValue extends CellData = CellData> = Header<AppTableFeatures, TData, TValue>;
export type AppHeaderGroup<TData extends RowData> = HeaderGroup<AppTableFeatures, TData>;
